import { AiRequestMetadataInput } from "@/modules/chats/services/ai/ch/__generated__/chChatHealthInformationCopilotQuery.graphql"
import {
  chChatHealthInformationCopilotQuery,
  ChHealthInformationCopilot,
} from "@/modules/chats/services/ai/ch/chChatHealthInformationCopilotQuery"
import {
  deChatHealthInformationCopilotQuery,
  DeHealthInformationCopilot,
} from "@/modules/chats/services/ai/de/deChatHealthInformationCopilotQuery"
import { Country } from "@/types/__generated__/union-types"

export const chatHealthInformationCopilotQuery = (country: Country, aiRequestMetadata: AiRequestMetadataInput) => {
  if (country === "DE") {
    return deChatHealthInformationCopilotQuery(aiRequestMetadata)
  }
  return chChatHealthInformationCopilotQuery(aiRequestMetadata)
}

export type HealthInformationCopilot = ChHealthInformationCopilot | DeHealthInformationCopilot
